import api from '@/core/api/client';

export interface CompanyInvoice {
  id: string; status: 'OPEN' | 'OVERDUE' | 'PARTIALLY_PAID' | 'PAID' | 'CANCELED'; amount: number; currency: string;
  paidAmount: number; balance: number; createdAt: string; dueDate: string; paidAt: string | null;
  periodStart: string; periodEnd: string; collectionProvider: string;
  items: InvoiceLine[];
}
export interface InvoiceLine { description: string; quantity: number; unitAmount: number }
export interface InvoicePayment { id: string; amount: number; paidAt: string; note: string; createdBy: string; reversedAt: string | null; reversalReason: string | null }
export interface InvoiceEvent { id: string; action: string; actorEmail: string; createdAt: string; details: { reason?: string; note?: string; amount?: number } }
export interface InvoiceDetail extends CompanyInvoice { payments: InvoicePayment[]; events: InvoiceEvent[] }
export interface CompanyInvoices {
  invoices: CompanyInvoice[]; hasMore: boolean; page: number;
}
export async function updateCompanyCollection(companyId: string, input: { requestKey: string; subscriptionId: string; provider: 'MANUAL'; status: 'ACTIVE' | 'TRIALING' | 'CANCELED' }) {
  return (await api.post(`/companies/${companyId}/collection`, input)).data;
}
export async function listCompanyInvoices(companyId: string, page = 1): Promise<CompanyInvoices> {
  const response = await api.get<{ data: CompanyInvoices }>(`/companies/${companyId}/invoices`, { params: { page, limit: 50 } });
  return response.data.data;
}
export async function getCompanyInvoice(companyId: string, invoiceId: string): Promise<InvoiceDetail> {
  return (await api.get<{ data: InvoiceDetail }>(`/companies/${companyId}/invoices/${invoiceId}`)).data.data;
}
export async function createCompanyInvoice(companyId: string, input: { requestKey: string; currency: string; items: InvoiceLine[]; periodStart: string; periodEnd: string; dueDate: string }) {
  return (await api.post(`/companies/${companyId}/invoices`, input)).data;
}
export async function payCompanyInvoice(companyId: string, invoiceId: string, input: { requestKey: string; amount: number; paidAt: string; note: string }) {
  return (await api.post(`/companies/${companyId}/invoices/${invoiceId}/payments`, input)).data;
}
export async function reverseCompanyInvoicePayment(companyId: string, invoiceId: string, paymentId: string, reason: string) {
  return (await api.post(`/companies/${companyId}/invoices/${invoiceId}/payments/${paymentId}/reverse`, { reason })).data;
}
export async function cancelCompanyInvoice(companyId: string, invoiceId: string, reason: string) {
  return (await api.post(`/companies/${companyId}/invoices/${invoiceId}/cancel`, { reason })).data;
}
